import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import AccountTree from '@mui/icons-material/AccountTree';
import AdjustIcon from '@mui/icons-material/Adjust';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import Assistant from '@mui/icons-material/Assistant';
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';
import Statistics from '@mui/icons-material/BarChart';
import Class from '@mui/icons-material/Class';
import Dashboard from '@mui/icons-material/Dashboard';
import DatasetOutlined from '@mui/icons-material/DatasetOutlined';
import Gavel from '@mui/icons-material/Gavel';
import Group from '@mui/icons-material/Group';
import Insights from '@mui/icons-material/Insights';
import LocalPostOffice from '@mui/icons-material/LocalPostOffice';
import Person from '@mui/icons-material/Person';
import PersonOutlineOutlined from '@mui/icons-material/PersonOutlineOutlined';
import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck';
import RequestQuote from '@mui/icons-material/RequestQuote';
import Schedule from '@mui/icons-material/Schedule';
import SchoolIcon from '@mui/icons-material/School';
import Settings from '@mui/icons-material/Settings';
import SettingsAccessibility from '@mui/icons-material/SettingsAccessibility';
import WaterfallChart from '@mui/icons-material/WaterfallChart';

export const SidebarIcons = {
  Dashboard,
  Statistics,
  Group,
  AccountTree,
  LocalPostOffice,
  Insights,
  Gavel,
  RequestQuote,
  WaterfallChart,
  DatasetOutlined,
  Schedule,
  Class,
  Person,
  Assistant,
  Settings,
  SettingsAccessibility,
  AccountCircleOutlinedIcon,
  BadgeOutlinedIcon,
  PersonOutlineOutlined,
  AssessmentOutlinedIcon,
  SchoolIcon,
  AdjustIcon,
  PlaylistAddCheckIcon,
};

export type SidebarIconType = keyof typeof SidebarIcons;
